import { log } from 'src/app/utils/logging';

export const mapVideoURL = (URL: string) => {
  if (!Boolean(URL)) {
    return;
  }

  const videoId =
    URL.split('/watch?v=')[1] ||
    URL.split('/watch/')[1] ||
    URL.split('/embed/')[1] ||
    URL.split('/shorts/')[1] ||
    URL.split('youtu.be/')[1];

  if (Boolean(videoId)) {
    return `https://www.youtube.com/embed/${videoId}`;
  }

  log.error('AddVideo | videoId not found', { videoId, URL });
};
